

import $http from '../services/AxiosInstance';
import { ICompaniasGPS, ICompaniasGPSResponse, ICompaniasGPSResponsePostPatch } from '../types/companiasGPS.type';


interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class CompaniesGPSRepository {
  static async getCompaniesGPS(params: Params = {}) {
    try {
      let url = `/companiesGPS`;
      if(params.page){
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createcompanyGPS(data: ICompaniasGPS): Promise<ICompaniasGPSResponse> {
    try {
      const response = await $http.post('/companiesGPS', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updatecompanyGPS(data: ICompaniasGPS): Promise<ICompaniasGPSResponsePostPatch> {
    try {
      const response = await $http.patch(`/companiesGPS/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deletecompanyGPS(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/companiesGPS/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restorecompanyGPS(id: number): Promise<number> {
    try {
      const response = await $http.patch(`/companiesGPS/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
}

export default CompaniesGPSRepository;
